import { render, staticRenderFns } from "./excludeStatus.vue?vue&type=template&id=bc652034&"
import script from "./excludeStatus.vue?vue&type=script&lang=js&"
export * from "./excludeStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports